import React, { useState, useEffect } from "react";
import DiscreteColorLegend from "react-vis/dist/legends/discrete-color-legend";
import Sidebar from "../components/Sidebar";
import ProfitLineChart from "../components/ProfitLineChart";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "../styling/sidebar.css";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { DateRangePicker, List } from "rsuite";
import { useHistory  } from "react-router-dom";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import AuthService from "../services/auth";
import UserService from "../services/user-service";
import CardView from "../components/CardView";
import Table from "../components/LandingData";
import IPopup from "../components/addIncomePop";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import ReactGA from "react-ga";
import {
  ReactComponent as CloseIcon,
  ReactComponent as CrossButton,
} from "../assets/cross.svg";
import { ReactComponent as AddIcon } from "../assets/addicon.svg";
import { ReactComponent as EyeIcon } from "../assets/eyeIcon.svg";
import moment from "moment";
import { toast } from "react-toastify";
import _ from "lodash";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "../styling/table.css";
import { Button, ListItem, ListItemText } from "@material-ui/core";
import GoalModal from "../components/GoalModal";
import CustomModal from "../components/UI/CustomModal";
import WelcomePopup from "../components/onboarding/popups/welcome";
import PopoverView from "../components/UI/PopoverView";
import { ArrowContainer } from "react-tiny-popover";
import cs from "classnames";
import CustomButton from "../components/UI/CustomButton/inedx";
import QuestionMark from "../assets/Icon/QuestionMark";
import Popover from "@mui/material/Popover";
import { Checkbox, FormControlLabel, ListItemButton } from "@mui/material";
import Mode from "../components/Mode";
import { BrowserView, MobileView } from "react-device-detect";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import larlogo from "../assets/logo-beta.png";
import { ReactComponent as Checkmark } from "../assets/checkMark.svg";
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';

export const colors = [
  "#21A179",
  "#7964D9",
  "#EB6F2D",
  "#98B514",
  "#0DA4B5",
  "#FFD436",
  "#FAAC02",
  "#EA4147",
  "#FC6897",
  "#006895",
];

const cache = createCache({
  key: "css",
  prepend: false,
});
const profitFilter = ["All Time", "Last Week", "Last Month", "Last Year"];
let change = 0;
let currentMonthMaxProfit;

function Landing() {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      mobileView: {
        padding: "200px 40px 507px 40px",
        width: 393,
        height: 851,
      },
      mobileLogoBox: {
        display: "flex",
        justifyContent: "center",
      },
      mobileLogo: {
        width: 101,
        height: 43,
        flexGrow: 0,
        padding: "0 0 1.4px",
      },
      contentSection1: {
        marginTop: 43.4,
        fontSize: 24,
        fontWeight: 600,
        textAlign: "center",
      },
      contentSection2: {
        marginTop: 24,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: 1.25,
        textAlign: "center",
      },
    })
  );
  const classes = useStyles();
  ReactGA.pageview(window.location.pathname);
  const history = useHistory();
  const cuurentCardMonth = new Date().getMonth();
  const [expGraphOp, setExpGraphOp] = useState(0);
  const [nrows, setnRows] = useState<any>([]);
  const [getAllExpenseData, setGetAllExpenseData] = useState([]);
  const [getAllRevenueData, setGetAllRevenueData] = useState([]);
  const [monthlySales, setMonthlySales] = useState("");
  const [monthlyExpense, setMonthlyExpense] = useState("");
  const [filterType, setFilterType] = useState<any>(0);
  const [sidebar, setSidebar] = useState(false);
  const [isClose, setISClose] = useState(true);
  const [sales, setSales] = useState<any>([]);
  const [expense, setExpense] = useState<any>([]);
  const [profit, setProfit] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMonthSale, setSelectedMonthSale] =
    useState<any>(cuurentCardMonth);
  const [selectedMonthExpense, setSelectedMonthExpense] =
    useState<any>(cuurentCardMonth);
  const [selectedMonthProfit, setSelectedMonthProfit] =
    useState<any>(cuurentCardMonth);
  const [salesSummary, setSalesSummary] = useState("");
  const [expenseSummary, setExpenseSummary] = useState("");
  const [profitSummary, setProfitSummary] = useState("");
  const [filterGraphData, setFilterGraphData] = useState<any>([-1]);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [graphColor, setGraphColor] = useState("#000000");
  const [swapState, setSwapState] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useState(false);
  const [tutorialStatus, setTutorialStatus] = useState(false);
  const [bussinessStatus, setBussinessStatus] = useState(false);
  const [goalMonth, setGoalMonth] = useState(cuurentCardMonth);
  const [openModal, setOpenModal] = useState(false);
  const [expenseGoalOpen, setExpenseGoalOpen] = useState(false);
  const [salesGoalOpen, setSalesGoalOpen] = useState(false);
  const [welcomeModal, setWelcomeModal] = useState(false);
  const [openBussinessModal, setOpenBussinessModal] = useState(false);
  const [businessDataLength, setBusinessDataLength] = useState(0);
  const [checkSalesData, setCheckSalesData] = useState<any>(false);
  const [seriesData, setSeriesData] = useState([]);
  const [onBoardStatus, setOnBoardStatus] = useState(false);
  const [onBoardTaskDone, setOnBoardTaskDone] = useState([]);
  const [showErrorMessage, setShowErrorMssage] = useState(false);
  const [incomeStreamName, setIncomeStreamName] = useState<any>("");
  var startDate = moment().subtract(1, "weeks").endOf("isoWeek").format();
  var endDate = moment().subtract(2, "weeks").startOf("isoWeek").format();
  var monthStart = moment().subtract(1, "months").startOf("month").format();
  var monthEnd = moment().subtract(1, "month").endOf("month").format();
  var yesterday = moment().subtract(1, "day").format();
  var weekDay = moment().subtract(7, "day").format();
  const [filterDate, setFilterDate] = useState<any>([]);
  const [activeModalStep, setActiveModalStep] = useState<any>(null);
  const [allStreamName, setAllStreamName] = useState([]);
  const hintStep = localStorage.getItem("hintStep");
  const [expSalesData, setExpSalesData] = useState<any>([]);
  const { afterToday } = DateRangePicker;
  const [reloadTableData, setReloadTableData] = useState(false);
  const [profitChartExpenseData, setProfitChartExpenseData] = useState<any>([]);
  const [profitChartSalesData, setProfitChartSalesData] = useState<any>([]);
  const [collpasedBox, setCollpasedBox] = useState(false);
  const [showAllTaskList, setShowAllTaskList] = useState(false);
  const [popoveropen, setPopoverOpen] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const matches = useMediaQuery('(max-width:393px)');

  const handleClick = (event) => {
    setPopoverOpen(event.currentTarget);
  };

  const handleClose = () => {
    setPopoverOpen(null);
  };
  const openBussinesses = Boolean(popoveropen);
  const id = openBussinesses ? 'simple-popover' : undefined;
  const eventTrackItem = (category, action, label) => {
    //console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  useEffect(() => {
    setActiveModalStep(hintStep);
    const iisVisited = localStorage.getItem("isVisited");
    if (iisVisited !== "true") setOpenModal(true);
    sessionStorage.setItem("bussinessStream",""); 
    sessionStorage.setItem("option","expense"); 
  }, []);

  useEffect(() => {
    localStorage.setItem("hintStep", activeModalStep);
  }, [activeModalStep]);

  useEffect(() => {
    if (nrows.length === 1) {
      setExpGraphOp(2);
    }
  }, [nrows]);

  const getTotalAmount = (records) => {
    const totalAmount = records.reduce(
      (acc, curVal: any) => acc + curVal.amount,
      0
    );
    return totalAmount;
  };

  const handleCloseModal = () => {
    setActiveModalStep("null");
  };

  const handleNext = () => {
    setActiveModalStep("1");
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const getAddition = (data) => {
    const temp = {};
    const totalAmount: number[] = [];
    const max = nrows.length;
    for (let i = 1; i <= max; i++) {
      temp[i] = 0;
    }
    data.forEach(function (a) {
      if (temp.hasOwnProperty(a.incomeStream)) {
        temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
      } else {
        temp[a.incomeStream] = a.amount;
      }
    });
    for (var item in temp) {
      totalAmount.push(temp[item]);
    }
    return totalAmount;
  };

  const expenseSalesDateFilter = (data, range) => {
    if (Number(expGraphOp) === 0) {
      const dateData = data
        .filter((item: any) => {
          if (moment(new Date(item.date)).isBetween(range[0], range[1])) {
            return item.date;
          }
        })
        .map((dates: any) => {
          return new Date(dates.date);
        });
      setFilterGraphData(dateData);
    } else {
      const filterDateData = data.filter((item: any) => {
        return item.incomeStream === expGraphOp - 1;
      });
      const dateData = filterDateData
        .filter((item: any) => {
          if (moment(new Date(item.date)).isBetween(range[0], range[1])) {
            return item.date;
          }
        })
        .map((dates: any) => {
          return new Date(dates.date);
        });
      setFilterGraphData(dateData);
    }
  };

  useEffect(()=>{
    UserService.getSale().then((response) => {
      const salesData = response.data.sale
      const profitChartSales = salesData
      .filter((data: any) => {
        return moment(data.date).isBetween(
          new Date(weekDay), new Date()
          );
        })
        setProfitChartSalesData(profitChartSales)
      })
      UserService.getExpense().then((response) => {
        const incomeData = response.data.expense
        const profitChartExpense = incomeData
        .filter((data: any) => {
          return moment(data.date).isBetween(
            new Date(weekDay), new Date()
            );
          })
          setProfitChartExpenseData(profitChartExpense)
        })
      },[])
      
      useEffect(() => {
        if (filterGraphData.length <= 0) {
          setShowErrorMssage(true);
        } else {
          setShowErrorMssage(false);
        }
      }, [filterGraphData]);
      
      useEffect(() => {
        const onBoarding = UserService.onBoardingQuestionsCheck().then(
          (response) => {
            const onBoardData = response.data;
        if (onBoardData.status) {
          setOnboardingStatus(true);
          setSwapState(true);
        } else {
          history.push("/onboarding");
        }
      }
      );
      const tutorial = UserService.getTutStatus().then((response) => {
        const tutData = response.data;
        if (tutData.status) {
          setTutorialStatus(true);
        } else if (swapState) {
          history.push("/tutorial");
        }
      });
      UserService.getIncome().then((response) => {
        setBusinessDataLength(response.data.iname.length);
        var iname = response.data.iname.map((data, index) => {
          return {
            label: data,
            value: index,
          };
        });
        setAllStreamName(iname);
        const data = response.data;
        if (data.iname.length === 0) setIsLoading(false);
        setnRows(data.iname);
      });
      UserService.getExpense().then((response) => {
        const expenseData = response.data.expense;
      if (expenseData.length > 0) {
        setGetAllExpenseData(expenseData);
        setExpSalesData([...expenseData]);
        const allExpenseTotal = getTotalAmount(expenseData);
        const filteredExpenseData = expenseData.filter(
          (item: any) =>
          moment(item.date).week() === moment().week()
          );
          const currentMonthTotalExpense = getTotalAmount(filteredExpenseData);
          const expensePercentage = (
            (currentMonthTotalExpense * 100) /
            allExpenseTotal
            ).toFixed(1);
            setMonthlyExpense(expensePercentage);
          }
          UserService.getSale().then((response) => {
            const salesData = response.data.sale;
            setExpSalesData([...expenseData, ...salesData]);
            if (salesData.length > 0) {
              setGetAllRevenueData(response.data.sale);
              const allSalesTotal = getTotalAmount(salesData);
              const filteredSalesData = salesData.filter(
                (item: any) =>
                moment(item.date).week() === moment().week()
                );
                const currentMonthTotalSales = getTotalAmount(filteredSalesData);
                const salesPercentage = (
                  (currentMonthTotalSales * 100) /
                  allSalesTotal
                  ).toFixed(1);
                  setMonthlySales(salesPercentage);
                }
              });
            });
            (profitChartExpenseData.length || profitChartSalesData.length > 0) ? setFilterDate([new Date(weekDay),new Date()])
            :setFilterDate([new Date(endDate), new Date(startDate)]);
            
            setOpenModal(true);

            //eslint-disable-next-line
          }, [reloadTableData, profitChartExpenseData,profitChartSalesData]);

  useEffect(() => {
    expenseSalesDateFilter(expSalesData, filterDate);
  }, [expSalesData, expGraphOp, filterDate]);

  useEffect(() => {
    if (
      nrows.length > 0 ||
      (getAllExpenseData.length > 0 && getAllRevenueData.length > 0)
    ) {
      calculateAmountByMonth(cuurentCardMonth, "Revenue");
      calculateAmountByMonth(cuurentCardMonth, "Expenses");
      calculateAmountByMonth(cuurentCardMonth, "Profit");
      setIsLoading(false);
    }
    //eslint-disable-next-line
  }, [nrows, getAllRevenueData, getAllExpenseData]);

  useEffect(() => {
    UserService.onBoardingTaskBuisCheck().then((response) => {
      setBussinessStatus(response.data.status);
      if (response.data.status === false) {
        setOpenBussinessModal(true);
      } else {
        setOpenBussinessModal(false);
      }
    });
    UserService.onBoardingTasksCheck().then((response) => {
      if (response.data.status === false) {
        if (
          response.data.tasksDone[0] === true &&
          response.data.tasksDone[1] === true &&
          response.data.tasksDone[2] === true &&
          response.data.status === false
        ) {
          setWelcomeModal(true);
        } else {
          setWelcomeModal(false);
          (response.data.tasksDone[0] === false && response.data.tasksDone[1] === false && response.data.tasksDone[2] === false) ? setOnBoardStatus(true) :setOnBoardStatus(false);
          onBoardStatus ? setCollpasedBox(false) : setCollpasedBox(true);
        }
      } else {
        setOnBoardStatus(false);
        setCollpasedBox(false);
      }
      setOnBoardTaskDone(response.data.tasksDone);
    });
  }, [reloadTableData]);

  const displayDataArray = (data, cardMonth) => {
    const filteredData = data.filter((item: any) => {
      if (cardMonth === 12) {
        var lastMonth = moment(lastMonth).subtract(13, "months").endOf("month");
        return new Date(item.date) > lastMonth._d;
      } else {
        return moment(item.date).month() === cardMonth;
      }
    });
    return getAddition(filteredData);
  };

  const calculateAmountByMonth = (cardMonth, type) => {
    switch (type) {
      case "Revenue":
        setSelectedMonthSale(cardMonth);
        const salesDataArray = displayDataArray(getAllRevenueData, cardMonth);
        const salesData = UserService.makeCardArray(nrows, salesDataArray);
        const currentMonthMaxSale = _.maxBy(salesData, "amount");
        currentMonthMaxSale?.amount === 0
          ? setSalesSummary(
              `None of your businesses made sales in ${cardMonth ===12 ? `Last Year`: moment.months(
                cardMonth
              )}`
            )
          : setSalesSummary(
              `${
                currentMonthMaxSale?.name
              } made the most sales in ${cardMonth ===12 ? `Last Year`: moment.months(cardMonth)}`
            );
        var totalSales = salesDataArray.reduce((x, y) => x + y, 0);
        setCheckSalesData(totalSales === 0);
        setSales(salesData);
        break;
      case "Expenses":
        setSelectedMonthExpense(cardMonth);
        const expenseDataArray = displayDataArray(getAllExpenseData, cardMonth);
        const expensesData = UserService.makeCardArray(nrows, expenseDataArray);
        const currentMonthMaxExpense = _.maxBy(expensesData, "amount");
        currentMonthMaxExpense?.amount === 0
          ? setExpenseSummary(
              `None of your businesses had expenses in ${cardMonth ===12 ? `Last Year`: moment.months(
                cardMonth
              )}`
            )
          : setExpenseSummary(
              `${
                currentMonthMaxExpense?.name
              } had the most expenses in ${cardMonth ===12 ? `Last Year`: moment.months(cardMonth)}`
            );
        setExpense(expensesData);
        break;
      case "Profit":
        setSelectedMonthProfit(cardMonth);
        const dataOfSales = displayDataArray(getAllRevenueData, cardMonth);
        const dataOfExpense = displayDataArray(getAllExpenseData, cardMonth);
        const profitDataArray = dataOfSales.map(
          (sales, index) => sales - dataOfExpense[index]
        );
        const profitData = UserService.makeCardArray(nrows, profitDataArray);
        currentMonthMaxProfit = _.maxBy(profitData, "amount");
        currentMonthMaxProfit?.amount <= 0
          ? setProfitSummary(
              `None of your businesses were profitable in ${cardMonth ===12 ? `Last Year`: moment.months(
                cardMonth
              )}`
            )
          : setProfitSummary(
              `${
                currentMonthMaxProfit?.name
              } was your most profitable business in ${cardMonth ===12 ? `Last Year`: moment.months(cardMonth)}`
            );
        setProfit(profitData);
        break;
    }
  };

  useEffect(() => {
    const result = nrows.map((item, index) => {
      return {
        title: item,
        color: colors[index],
      };
    });
    setSeriesData(result);
  }, [nrows]);

  const handleExpOption = (event) => {
    setExpGraphOp(event.target.value);
    setGraphColor(colors[event.target.value - 2]);
    if (change === 0) {
      change = 1;
    }
    change = change * -1;
    var iname = nrows.filter((data, index) => {
      if (index === event.target.value - 2) {
        return data[0];
      }
    });
    setIncomeStreamName(iname[0]);
  };

  const calculateGoal = (e) => {
    setGoalMonth(e);
  };

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
  }

  const allMonths = moment.monthsShort();
  componentMounted();

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      fontWeight: "bolder",
      color: "#48b7a7",
      padding: "10px 26px 10px 10px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
    "& .MuiSelect-icon": {
      fill:"#41c175"
    }
  }));
  const TaskList = styled(Box)(() => ({
    background: "#4cc988",
    color: "#fff",
    maxWidth: showAllTaskList ? "300px" : "40px",
    position: "fixed",
    right: 0,
    zIndex: 100,
    top: "20%",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    padding: showAllTaskList ? "20px 20px" : "20px 0",
    fontWeight: "bold",
  }));

  const TaskListWrapper = styled(Box)(() => ({
    display: "flex",
    height: "17px",
    marginBottom: "2px",
    alignItems: "center",
  }));

  const TaskCheckList = styled(Checkbox)(() => ({
    "&.MuiButtonBase-root": {
      color: "white !important",
    },
  }));

  const handleBussinessModal = () => {
    bussinessStatus === false
      ? setOpenBussinessModal(true)
      : setOpenBussinessModal(false);
    setOnBoardStatus(false);
    (!onBoardTaskDone[0] || !onBoardTaskDone[1] || !onBoardTaskDone[2]) && setCollpasedBox(true);
  };

  const handleListItem=(item)=>{
   history.push(`/stream/ + ${item}/calculator`)
   }
  const TotalBusiness= allStreamName?.map((item:any)=> item.label);

  return (
    <div>
      {!matches?
      <div>
        <>
          {openBussinessModal && (
            <Popup open={true} onClose={() => setOpenBussinessModal(false)}>
              <div className="mode">
                <button
                  className="close"
                  onClick={() => setOpenBussinessModal(false)}
                >
                  &times;
                </button>
                <div className="header">Add Business</div>
                <div className="content">
                  <IPopup closeModal={setOpenBussinessModal} setReloadTableData={setReloadTableData}/>
                  <br />
                </div>
              </div>
            </Popup>
          )}
          <div>
            {collpasedBox && (
              <>
                <TaskList onClick={() => setShowAllTaskList((prevState)=>!prevState)}>
                  <TaskListWrapper className="mb-3">
                    <TaskCheckList checked={onBoardTaskDone[0]} value={onBoardTaskDone[0]}></TaskCheckList>
                    Overview Page : Add Business
                  </TaskListWrapper>

                  <TaskListWrapper className="mb-3">
                    <TaskCheckList checked={onBoardTaskDone[1]} value={onBoardTaskDone[1]}></TaskCheckList>
                    Expense Tracker : Add Expense
                  </TaskListWrapper>

                  <TaskListWrapper>
                    <TaskCheckList checked={onBoardTaskDone[2]} value={onBoardTaskDone[2]}></TaskCheckList>
                    Sales Log : Add Sale
                  </TaskListWrapper>
                </TaskList>
              </>
            )}

            {onBoardStatus && (
              <Modal
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box className="getting-started">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ mt: 2 }}
                  >
                    Getting Started
                    <CrossButton
                      className="geeting-close"
                      onClick={handleBussinessModal}
                    />
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    className="getting-started-title"
                    sx={{ m: 2 }}
                  >
                    Make sure to complete these 3 tasks to start using Sotira!
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ m: 2 }}>
                    <div className="d-flex align-items-center mb-3">
                      <Checkmark
                        className={`${
                          !onBoardTaskDone[0] && "onboard-status"
                        } mr-3`}
                      />
                      Overview Page : Add Business
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <Checkmark
                        className={`${
                          !onBoardTaskDone[1] && "onboard-status"
                        } mr-3`}
                      />
                      Expense Tracker : Add Expense
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <Checkmark
                        className={`${
                          !onBoardTaskDone[2] && "onboard-status"
                        } mr-3`}
                      />
                      Sales Log : Add Sale
                    </div>
                  </Typography>
                </Box>
              </Modal>
            )}
            {welcomeModal && (
              <Modal
                open={welcomeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box className="box-content d-flex justify-content-around flex-column">
                  <div>
                    <Typography
                      id="modal-modal-description"
                      className="modal-description ml-3"
                    >
                      Congrats! You’re ready to take full advantage of Sotira.
                    </Typography>
                  </div>
                  <div>
                    <Button
                      variant="outlined"
                      className="btn-close text-white border-white"
                      onClick={() => {
                        localStorage.setItem("isVisited", "true");
                        setWelcomeModal(false);
                        bussinessStatus === false
                          ? setOpenBussinessModal(true)
                          : setOpenBussinessModal(false);
                      }}
                    >
                      OK
                    </Button>
                  </div>
                </Box>
              </Modal>
            )}
          </div>
          <CacheProvider value={cache}>
            <Container fluid>
              <Row>
                <Sidebar sidebar={sidebar} setSidebar={setSidebar} reloadTableDataAPI={reloadTableData} setReloadTableDataAPI={setReloadTableData} />
                <Col
                  className={
                    sidebar
                      ? `overview-section`
                      : `overview-section sidebar-collapse`
                  }
                >
                  <Row className="overview-section-heading">
                    <Col className="p-0">
                      <div className={sidebar?`Topbar-sidebar`:`Topbar`}>
                        <div className="overview">My Businesses</div>
                        
                        <div className="d-flex align-items-center  " >
                        <Popup
                          trigger={
                            <button
                              className={
                                sidebar
                                  ? `add-bussiness-button-sidebar`
                                  : `add-bussiness-button`
                              }
                              onClick={() => {
                                eventTrackItem(
                                  "Add Business",
                                  "Add Business",
                                  "Button"
                                );
                              }}
                            >
                              <AddIcon className="plus-icon" /> Add Business
                            </button>
                          }
                          modal
                          nested
                          className="popup-income"
                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="header">Add Business</div>
                              <div className="content">
                                <IPopup closeModal={close} setReloadTableData={setReloadTableData} />
                                <br />
                              </div>
                            </div>
                          )}
                        </Popup>
                        {TotalBusiness.length==0?
                       <Tooltip title="Add a Business">
                        <button
                       className={
                         sidebar
                           ? `add-bussiness-button-sidebar `
                           : `add-bussiness-button mr-3`
                       }
                     disabled
                     >
                       <AddIcon className="plus-icon" /> Calculate Pricing
                     </button></Tooltip>:
                     TotalBusiness.length==1?
                           <button
                             className={
                               sidebar
                                 ? `add-bussiness-button-sidebar`
                                 : `add-bussiness-button`
                             }
                             onClick={() => {
                                history.push(`/stream/ + ${nrows[0]}/calculator`);
                             }}
                           >
                             <AddIcon className="plus-icon" /> Calculate Pricing
                           </button>
                       : 
                       <button
                       className={
                         sidebar
                           ? `add-bussiness-button-sidebar`
                           : `add-bussiness-button`
                       }
                       onClick={
                        handleClick}
                     >
                       <AddIcon className="plus-icon" /> Calculate Pricing
                     </button>
}
                       
                        </div>
                        
                      </div>
                    </Col>

                  </Row>
                  {isClose && (
                    <Row className="initial-summary">
                      <Col lg={8}>
                        <div
                          className={
                            sidebar
                              ? "summary-content-sidebar"
                              : "summary-content"
                          }
                        >
                          {
                            <p className="summary-message m-0">
                              Welcome back! Your sales are up {" "}
                              <span className="summary-text">
                                {+monthlySales ? +monthlySales : 0}%
                              </span>{" "}
                              and your expenses are down{" "}
                              <span className="summary-text">
                                {+monthlyExpense ? +monthlyExpense : 0}%
                              </span>{" "}
                              this week. Keep up the good work!
                              {/* {+monthlySales === +monthlyExpense
                                ? " Keep up the good work!"
                                : +monthlySales > +monthlyExpense
                                ? " Great job!"
                                : " Your expenses were a little high in this week. "} */}
                            </p>
                          }
                          <CrossButton
                            className="cross-icon"
                            onClick={() => setISClose(!isClose)}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row
                    className={
                      sidebar ? `graph-section-sidebar` : `graph-section`
                    }
                  >
                    <Col lg={3} className="source-container">
                      <div className="d-flex flex-column mt-4 pt-1">
                        <span className="graph-heading">Profit Graph</span>
                        <FormControl variant="standard">
                          <Select
                            id="exp-source-option"
                            value={expGraphOp}
                            className="income-source"
                            onChange={handleExpOption}
                            input={
                              <BootstrapInput className="bootstrapInput" />
                            }
                          >
                            <MenuItem
                              className="source-dropdown"
                              key="all"
                              value={0}
                            >
                              All Businesses
                            </MenuItem>
                            {nrows.map((graph, index) => (
                              <MenuItem
                                className="source-dropdown"
                                key={graph}
                                value={index + 2}
                              >
                                {graph}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Box
                          sx={{
                            marginTop: 3,
                            marginBottom: 3,
                            alignItems: "center",
                          }}
                          className="date-range-popover"
                        >
                          <DateRangePicker
                            onChange={(e) => {
                              setFilterDate(e);
                              change = change * -1;
                            }}
                            placeholder="Select Date"
                            className="dateRange"
                            onClean={() =>
                              (profitChartExpenseData.length || profitChartSalesData.length >0)
                              ?
                                setFilterDate([new Date(weekDay), new Date()]):
                               setFilterDate([endDate, startDate])
                            }
                            defaultCalendarValue={[new Date(monthStart), new Date()]}
                            disabledDate={afterToday()}
                            ranges={[
                              {
                                label: "today",
                                value: [new Date(), new Date()],
                              },
                              {
                                label: "yesterday",
                                value: [new Date(yesterday), new Date(yesterday)],
                              },
                              {
                                label: "last7Days",
                                value: [new Date(weekDay), new Date()],
                              },
                              {
                                label: "Last Month",
                                value: [new Date(monthStart), new Date(monthEnd)],
                              },
                            ]}
                            renderValue={(value) => {
                              return (
                                moment(value[0]).format("MM/DD/YYYY") +
                                " - " +
                                moment(value[1]).format("MM/DD/YYYY")
                              );
                            }}
                          />
                          <Typography
                            aria-owns={open ? "mouse-over-popover" : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}
                          >
                            <QuestionMark className="ml-3" />
                          </Typography>
                          <Popover
                            id="mouse-over-popover"
                            sx={{
                              pointerEvents: "none",
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography sx={{ p: 1 }}>
                              You will only see data on the graph if data exists
                              during the selected time frame
                            </Typography>
                          </Popover>
                        </Box>
                        <DiscreteColorLegend
                          width={300}
                          items={seriesData}
                          className="source-label"
                        />
                      </div>
                    </Col>
                    <Col
                      lg={12}
                      xl={8}
                      className={sidebar ? `m-2` : `profit-container`}
                    >
                      {change === 0 && (
                        <ProfitLineChart
                          stream={-1}
                          range={filterDate}
                          activeModalStep={activeModalStep}
                          setActiveModalStep={setActiveModalStep}
                          streamName={incomeStreamName}
                          graphColor={graphColor}
                          showErrorMessage={showErrorMessage}
                          dateList={filterGraphData}
                        />
                      )}
                      {change === -1 && (
                        <ProfitLineChart
                          stream={expGraphOp - 1}
                          range={filterDate}
                          activeModalStep={activeModalStep}
                          setActiveModalStep={setActiveModalStep}
                          streamName={incomeStreamName}
                          graphColor={graphColor}
                          showErrorMessage={showErrorMessage}
                          dateList={filterGraphData}
                        />
                      )}
                      {change === 1 && (
                        <ProfitLineChart
                          stream={expGraphOp - 1}
                          range={filterDate}
                          activeModalStep={activeModalStep}
                          setActiveModalStep={setActiveModalStep}
                          streamName={incomeStreamName}
                          graphColor={graphColor}
                          showErrorMessage={showErrorMessage}
                          dateList={filterGraphData}
                        />
                      )}
                    </Col>
                  </Row>
                  {profit.length >= 1 &&
                    expense.length >= 1 &&
                    sales.length >= 1 && (
                      <Row
                        className={sidebar ? `card-row-sidebar` : `card-row`}
                      >
                        <Col lg={4} className="pl-xl-0 cards-column p-0">
                          <CardView
                            cardType="Revenue"
                            data={sales}
                            selectedCardMonth={selectedMonthSale}
                            loader={isLoading}
                            nrows={nrows}
                            summary={salesSummary}
                            checkSalesData={checkSalesData}
                            sideBar={sidebar}
                            calculateAmount={calculateAmountByMonth}
                            currentMonthMaxProfit={currentMonthMaxProfit}
                          />
                        </Col>
                        <Col lg={4} className="cards-column p-0">
                          <CardView
                            cardType="Profit"
                            data={profit}
                            selectedCardMonth={selectedMonthProfit}
                            loader={isLoading}
                            nrows={nrows}
                            summary={profitSummary}
                            checkSalesData={false}
                            sideBar={sidebar}
                            calculateAmount={calculateAmountByMonth}
                            currentMonthMaxProfit={currentMonthMaxProfit}
                          />
                        </Col>
                        <Col lg={4} className="pr-xl-0 cards-column p-0">
                          <CardView
                            cardType="Expenses"
                            data={expense}
                            selectedCardMonth={selectedMonthExpense}
                            loader={isLoading}
                            nrows={nrows}
                            summary={expenseSummary}
                            checkSalesData={false}
                            sideBar={sidebar}
                            calculateAmount={calculateAmountByMonth}
                            currentMonthMaxProfit={currentMonthMaxProfit}
                          />
                        </Col>
                      </Row>
                    )}
                  <Row className={sidebar ? "table-row-sidebar" : ""}>
                    <Col className="table-content">
                      <div
                        className={
                          sidebar ? `landing-table-sidebar` : `landing-table`
                        }
                      >
                        <div className="income-streams-table">
                          <div
                            className="table-main-header d-flex justify-content-between align-items-center"
                            id="table-main-header"
                          >
                            <div className="d-flex">
                              <PopoverView
                                isOpen={activeModalStep === "2"}
                                positions={["top"]}
                                parentElement={document.getElementById(
                                  "table-main-header"
                                )}
                                content={({
                                  position,
                                  targetRect,
                                  childRect,
                                  popoverRect,
                                }) => (
                                  <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                                    position={position}
                                    popoverRect={popoverRect}
                                    arrowColor={"#41c175"}
                                    arrowSize={20}
                                    arrowStyle={{ opacity: 0.7 }}
                                    childRect={childRect}
                                    arrowClassName="arrow-wrapper-right"
                                  >
                                    <div className="position-relative popover-wrapper">
                                      <div className="d-flex justify-content-end">
                                        <CloseIcon
                                          className={cs("closeIcon")}
                                          style={{ fill: "#fff" }}
                                          onClick={handleCloseModal}
                                        />
                                      </div>
                                      <div className="">
                                        You can manage your calculators and
                                        income streams here. This is where
                                        you’ll be able to add a new stream.
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="dot-list-wrapper">
                                          {[1, 2, 3, 4, 5, 6].map((list) => (
                                            <div
                                              key={list}
                                              className={cs("dots", {
                                                ["active-dots"]:
                                                  list <= +activeModalStep,
                                              })}
                                            />
                                          ))}
                                        </div>

                                        <CustomButton
                                          className="start-btn mt-0 mb-0"
                                          onClick={() =>
                                            setActiveModalStep("3")
                                          }
                                        >
                                          Next
                                        </CustomButton>
                                      </div>
                                    </div>
                                  </ArrowContainer>
                                )}
                              >
                                <span
                                  className="stream-title"
                                  id="incomeStreams"
                                >
                                  All Businesses{" "}
                                </span>
                              </PopoverView>

                              <div>
                                <FormControl
                                  sx={{ m: 1, width: 200, margin: 3 }}
                                  defaultValue={0}
                                >
                                  <Select
                                    id="timeframe-option"
                                    value={filterType}
                                    onChange={(e) =>
                                      setFilterType(e.target.value)
                                    }
                                    autoWidth
                                    sx={{
                                      color: "#48B7A7",
                                      fontWeight: 700,
                                    }}
                                    input={
                                      <BootstrapInput className="bootstrapInput" />
                                    }
                                  >
                                    {profitFilter.map((item, index) => (
                                      <MenuItem
                                        className="timeframe"
                                        key={item}
                                        value={index}
                                      >
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>

                            {profit.length === 1 &&
                              sales.length === 1 &&
                              expense.length === 1 && (
                                <div className="d-flex mt-2">
                                  <button
                                    className="card-goal expense-goal-color"
                                    onClick={() => {
                                      eventTrackItem(
                                        "Card Item",
                                        "View Exp Cap",
                                        "Button"
                                      );
                                      setExpenseGoalOpen(true);
                                    }}
                                  >
                                    <EyeIcon className="mr-3" />
                                    View expense caps
                                  </button>
                                  <button
                                    className="card-goal sales-goal-color"
                                    onClick={() => {
                                      eventTrackItem(
                                        "Card Item",
                                        "View Sales Goal",
                                        "Button"
                                      );
                                      setSalesGoalOpen(true);
                                    }}
                                  >
                                    <EyeIcon className="mr-3" />
                                    View sales goals
                                  </button>
                                </div>
                              )}
                            <GoalModal
                              open={expenseGoalOpen}
                              setOpen={setExpenseGoalOpen}
                              goalTitle="Set an Expense Cap"
                              content="I want to spend maximum of"
                              goalButtonList={["Day", "Week", "Month", "Year"]}
                              addGoal="Add Expense cap"
                              nrows={nrows}
                              cardType="Expenses"
                            />
                            <GoalModal
                              open={salesGoalOpen}
                              setOpen={setSalesGoalOpen}
                              goalTitle="Set a Sales Goal"
                              content="I want to earn"
                              goalButtonList={["Day", "Week", "Month", "Year"]}
                              addGoal="Add goal"
                              nrows={nrows}
                              cardType="Revenue"
                            />
                          </div>

                          <Table
                            filterType={filterType}
                            activeModalStep={activeModalStep}
                            handleClose={handleCloseModal}
                            reloadTableDataAPI={reloadTableData}
                            setReloadTableDataAPI={setReloadTableData}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
            <CustomModal
              secondary
              open={activeModalStep === "0"}
              handleClose={handleCloseModal}
            >
              <WelcomePopup handleSave={handleNext} />
            </CustomModal>
          </CacheProvider>
          <Mode />
        </>
      </div>:
      <MobileView className={classes.mobileView}>
        <div className={classes.mobileLogoBox}>
          <img alt="logo" className={classes.mobileLogo} src={larlogo} />
        </div>
        <div className={classes.contentSection1}>
          <p>Thank you for signing up for Sotira!</p>
        </div>
        <div className={classes.contentSection2}>
          <p>
            Add your business and access pricing tools. Please {" "}
            <a
              href="/auth/login"
              style={{ color: "#48b7a7", fontWeight: "bold" }}
            >
              login
            </a>{" "}
            on desktop for all other features.
          </p>
        </div>
        <div className="Add-bussiness-mobileview">
      
                  <Popup
                          trigger={
                            <button
                              className={
                                sidebar
                                  ? `add-bussiness-button-sidebar`
                                  : `add-bussiness-button`
                              }
                              onClick={() => {
                                eventTrackItem(
                                  "Add Business",
                                  "Add Business",
                                  "Button"
                                );
                              }}
                            >
                              <AddIcon className="plus-icon" /> Add  Business
                            </button>
                          }
                          modal
                          nested
                          className="popup-income"
                          contentStyle={{minWidth:"260px"}}
                        >
                          {(close) => (
                            <div className="mode" >
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="header">Add Business</div>
                              <div className="content" >
                                <IPopup closeModal={close} setReloadTableData={setReloadTableData} />
                                <br />
                              </div>
                            </div>
                          )}
                        </Popup>
        </div>
        <div className="Add-bussiness-mobileview">
        <button
                       className={
                         sidebar
                           ? `add-bussiness-button-sidebar`
                           : `add-bussiness-button`
                       }
                       onClick={
                        handleClick}
                     >
                       <AddIcon className="plus-icon" /> Calculate Pricing
                     </button>
        </div>
     
      </MobileView>}
       <Popover
        id={id}
        open={openBussinesses}
        anchorEl={popoveropen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorPosition={{top:0,left:20}}
        sx={{left:"1040"}}
  
      >
        <List >
          {TotalBusiness?.map((item,index)=>{
            return(
            <MenuItem sx={{width:"210px",paddingLeft:"15px !important"}}  onClick={(e)=>handleListItem(item)}>
          {item}
            </MenuItem>)
          })}
        </List>
      </Popover>
    </div>
  );
}

export default Landing;
